'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _DualColumnTableComponent = require('./DualColumnTableComponent');

var _DualColumnTableComponent2 = _interopRequireDefault(_DualColumnTableComponent);

var _SectionHeaderComponent = require('./SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a data section of the confirmation page.
 */
var ConfirmationInfoSectionComponent = function ConfirmationInfoSectionComponent(_ref) {
  var section = _ref.section;
  return _react2.default.createElement(
    'div',
    { className: 'ingle-form-confirmation-info-section' },
    _react2.default.createElement(
      _SectionHeaderComponent2.default,
      null,
      section.header
    ),
    _react2.default.createElement(
      _reactBootstrap.Col,
      { xs: 12 },
      _react2.default.createElement(_DualColumnTableComponent2.default, {
        rows: section.items,
        keys: {
          th: 'text',
          td: 'value'
        },
        bordered: true,
        striped: true
      })
    )
  );
};

ConfirmationInfoSectionComponent.propTypes = {
  section: _react2.default.PropTypes.shape({
    header: _react2.default.PropTypes.string.isRequired,
    items: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
      text: _react2.default.PropTypes.string.isRequired,
      value: _react2.default.PropTypes.string.isRequired
    })).isRequired
  }).isRequired
};

exports.default = ConfirmationInfoSectionComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/ConfirmationInfoSectionComponent.jsx
// module id = 1654
// module chunks = 0